<!-- Container for the page -->
<div class="w-full min-h-screen bg-black flex flex-col items-center">

    <!-- Header bar -->
    <div class="relative w-full h-[64px] flex px-[38px] items-center bg-black z-20">
        <div class="flex h-[48px] justify-center items-center gap-[10px]">
            <img src="png/ArrowLeft.svg" (click)="onCoverage()" alt="icon" class="object-contain w-[24px] h-[24px] cursor-pointer">
            <h2 class="text-[#FCFCFD] font-manrope text-[18px] font-bold leading-[120%]">
                {{'Premium Estimation' | translate}}
            </h2>
        </div>
    </div>

    <div class="flex w-[90%] p-2 flex-col justify-center items-center gap-13 rounded-[8px] bg-black mb-9">
        <div class="flex w-full items-start p-4 gap-4 self-stretch mb-9 bg-[#141011] rounded-[8px]">
            <div class="flex flex-col justify-between items-start flex-1 self-stretch">
                <span class="self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[16px]">
                    {{'Your premium' | translate}}
                </span>
                <h1 class="self-stretch text-[#F5375C] font-manrope text-[20px] font-semibold leading-[24px]">
                    {{ responseData ?? '0' | number}} {{'VND/year' | translate}}
                </h1>
                <!-- <p class="self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[16px]">
                    Per year, billed annually
                </p> -->
            </div>
            <img src="png/8622528_3963093 1.svg" alt="image" class="w-[94px] h-[94px] rounded-[8px]">
        </div>

        <div class="flex w-full p-4 flex-col gap-3 bg-[#141011] relative rounded-[8px] mb-9">
            <div class="flex justify-center items-center gap-3 self-stretch">
                <img src="/png/CheckCircle.svg" alt="Check Circle" class="w-6 h-6 flex-shrink-0" style="fill: #1AAA69;" />
                <h1
                    class="text-[#FCFCFD] font-[Manrope] text-[14px] not-italic font-semibold leading-[43.556px] flex-[1_0_0]">
                    {{'Main Coverage' | translate}}
                </h1>
            </div>

            <!-- Divider -->
            <hr class="w-[95%] justify-start border-t border-[rgba(217,217,217,0.12)] my-2 mt-0" />

            <h3
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
                {{'Long-term Hospitalization Allowance' | translate}}
            </h3>
            <p
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]">
                {{'In case the insured suffers an accident or illness within the policy coverage, requiring inpatient
                treatment for 30 days
                or more and continuous leave of at least 60 days (including hospitalization period)' | translate}}
            </p>
            <h3
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
                {{'Death benefit' | translate}}
            </h3>
            <p
                class="justify-center items-center self-stretch text-[#CFCACC] font-[manrope] text-[12px] font-normal leading-[140%]">
                {{'Covers death caused by accident, illness, or disease during long-term treatment' | translate}}
            </p>
        </div>

        <div class="flex w-full p-4 flex-col gap-3 bg-[#141011] relative rounded-[8px] mb-9">
            <div class="flex justify-center items-center gap-3 self-stretch">
                <img src="/png/CheckCircle.svg" alt="Check Circle" class="w-6 h-6 flex-shrink-0" style="fill: #1AAA69;" />
                <h1 class="text-[#FCFCFD] font-[Manrope] text-[14px] not-italic font-semibold leading-[43.556px] flex-[1_0_0]">
                    {{'Extended Coverage' | translate}}
                </h1>
            </div>
        
            <!-- Divider -->
            <hr class="w-[95%] justify-start border-t border-[rgba(217,217,217,0.12)] my-2 mt-0" />
        
            <h3
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
                {{'1. Enhanced Hospitalization Allowance' | translate}}
            </h3>
            <p
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]">
                {{'Extended conditions for the Long-term Hospitalization Allowance' | translate}}
            </p>
            <h3
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
                {{'2. Critical Illness Insurance' | translate}}
            </h3>
        <p class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]">
            {{'(cancer, heart attack, stroke)' | translate}}
        </p>
        
        <ol class="list-decimal text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]"
            style="counter-reset: section 2;">
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Early-stage Critical Illness' | translate}}
            </li>
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Late-stage Critical Illness' | translate}}
            </li>
        </ol>

        <h3
                class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
                {{'2. Critical Illness Insurance' | translate}}
            </h3>
        <p class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]">
            {{'(cancer, heart attack, stroke)' | translate}}
        </p>
        
        <ol class="list-decimal text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]"
            style="counter-reset: section 2;">
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Early-stage Critical Illness' | translate}}
            </li>
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Late-stage Critical Illness' | translate}}
            </li>
        </ol>

        <h3 class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-bold leading-[140%]">
            {{'3. Women’s Cancer Protection (Breast Cancer and Cervical Cancer)' | translate}}
        </h3>
        <!-- <p class="justify-center items-center self-stretch text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]">
            {{'(Breast Cancer and Cervical Cancer)' | translate}}
        </p> -->
        
        <ol class="list-decimal text-[#CFCACC] font-manrope text-[12px] font-normal leading-[140%]"
            style="counter-reset: section 2;">
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Early-stage' | translate}}
            </li>
            <li style="counter-increment: section 1; list-style-type: none;">
                {{'Late-stage' | translate}}
            </li>
        </ol>

        </div>  
        <div class="flex flex-col sm:w-full items-start gap-[10px] p-[12px_16px] rounded-[12px]"
            style="border-left: 4px solid #F5375C; background: #2D181E;">
            <span class="text-[var(--Grayscale-100,#FCFCFD)] font-[manrope] text-[16px] font-bold leading-[140%]">
                {{'Secure your financial peace of mind today' | translate}}
            </span>
        <p class="self-stretch text-white font-[Manrope] text-[16px] font-normal leading-[26px] rotate-[0.194deg]">
            {{'Protect your finances from income loss due to illness, accident, or unforeseen circumstances' | translate}}
        </p>
        <div class="justify-start"> 
            <div (click)="onCoverage()" 
                class="w-[200px] rounded-[8px] h-[50px] flex flex-col justify-center items-center self-center border border-[#F5375C] rounded-[8px]cursor-pointer transition-colors duration-300">
                <button class="text-[#F5375C] text-center font-[Manrope] text-[16px] font-bold leading-normal">
                    {{'Get Covered' | translate}}
                </button>
            </div>
        </div>
        </div>
    </div>
    <div (click)="onCoverage()" class="w-[90%]  bottom-0 left-0 right-0 z-20 bg-[#F03457] p-2 rounded-[8px] mx-auto ">
        <button type="button"
            class="w-full px-3 py-2 text-white rounded-[8px] font-primary font-bold text-lg flex justify-center items-center gap-2">
            {{'REGISTER NOW' | translate}}
        </button>
    </div>

</div>